import { useTranslation } from 'react-i18next';

import CalendarLine from '@/assets/icons/calendar_line.svg?component';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';
import { SelectMenu } from '@/components/molecules/SelectMenu';

import styles from './HealthStatusPeriodPicker.module.scss';

export type HealthStatusPeriod = 'daily' | 'weekly';

export interface HealthStatusPeriodPickerProps {
    value: HealthStatusPeriod;
    onChange: (period: HealthStatusPeriod) => void;
    menuPosition?: 'left' | 'right';
    disabled?: boolean;
}

const PERIOD_OPTIONS: HealthStatusPeriod[] = ['daily', 'weekly'];

const PERIOD_LABEL_KEY: Record<HealthStatusPeriod, string> = {
    daily: 'detail.common.periodDaily',
    weekly: 'detail.common.periodWeekly',
};

export default function HealthStatusPeriodPicker(props: HealthStatusPeriodPickerProps) {
    const { value, onChange, menuPosition = 'right', disabled = false } = props;
    const { t } = useTranslation('healthModule');

    return (
        <div className={styles.periodPicker}>
            <SelectMenu
                value={value}
                onChange={onChange}
                options={PERIOD_OPTIONS.map((period) => ({
                    value: period,
                    label: t(PERIOD_LABEL_KEY[period]),
                }))}
                disabled={disabled}
                icon={<SvgIcon icon={CalendarLine} size="medium" color="currentColor" />}
                align={menuPosition === 'right' ? 'end' : 'start'}
                triggerClassName={styles.toggle}
                menuClassName={styles.dropdownMenu}
            />
        </div>
    );
}
